import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { ProfileCard } from '@/components/profile/profile-card'
import { DeleteProfile } from '@/components/settings/delete-profile'
import { StudentSettings } from '@/components/settings/student-settings'
import { useProfilePresenter } from '@/presenters/profile.presenter'
import { useProfilePromotionalCodePresenter } from '@/presenters/profile-promotional-code.presenter'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_student/_layout/profile')({
  component: Profile,
})

function Profile() {
  const profilePresenter = useProfilePresenter()
  const promotionalCodePresenter = useProfilePromotionalCodePresenter()
  const authState = useAuthStore()
  const [isDirty, setIsDirty] = useState<boolean>(false)

  if (!authState.isAuthenticated || authState.role !== 'STUDENT') return null

  return (
    <div className="bg-gray-25 mx-auto flex w-full max-w-6xl flex-col gap-12 pb-32 pt-4">
      <div className="grid w-full grid-cols-1 gap-6 px-4 py-8 md:grid-cols-1 md:px-12">
        <ProfileCard
          presenter={profilePresenter}
          promotionalCodePresenter={promotionalCodePresenter}
        />
      </div>

      <div className="flex w-full flex-col px-4 md:px-12">
        <StudentSettings
          student={authState.user}
          updateAuth={authState.updateAuth}
          editPassword
          isDirty={isDirty}
          setIsDirty={setIsDirty}
        />

        <DeleteProfile id={authState.user.id} />
      </div>

      <div className="mt-8 flex w-full flex-col gap-6 px-4 pb-8 md:px-12">
        <p className="text-center text-xs text-slate-400">Version {APP_VERSION}</p>
      </div>
    </div>
  )
}
